module.exports = __webpack_public_path__ + "static/media/image 11.2209585c.png";